import { render, staticRenderFns } from "./input-benefit-info.vue?vue&type=template&id=9720c32a&scoped=true&"
import script from "./input-benefit-info.vue?vue&type=script&lang=js&"
export * from "./input-benefit-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9720c32a",
  null
  
)

export default component.exports